export default __webpack_public_path__ + "static/media/vitamin-e.3ea28b53.jpg";